import { HStack, Text, Tooltip } from '@chakra-ui/react';
import { StarRating } from './StarRating';
import { getBountyCountRange } from '../../utils/anonymizer';

export const ReputationBadge = ({ reputation, size = 'sm', anonymous = false }) => {
  if (!reputation) return null;

  const { rating = 0, completedBounties = 0 } = reputation;
  const countRange = getBountyCountRange(completedBounties);
  const hasRatings = rating > 0;

  return (
    <Tooltip
      label={
        anonymous
          ? `${countRange} completed bounties${hasRatings ? `, ${Math.round(rating)} star rating` : ''}`
          : `${completedBounties} completed bounties${hasRatings ? `, ${rating.toFixed(1)} avg rating` : ''}`
      }
      placement="top"
    >
      <HStack spacing={2} cursor="default">
        {hasRatings && <StarRating rating={rating} size={size === 'sm' ? 3 : 4} />}
        <Text fontSize={size} color="gray.500">
          {countRange} completed
        </Text>
      </HStack>
    </Tooltip>
  );
};
